import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { environment } from '../environments/environment';
import { ENVIRONMENT_INJECTION_TOKEN } from '@ls/models-environment';

import { routes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideToastr } from 'ngx-toastr';
import { NOTIFICATIONS_GLOBAL_CONFIG } from '@ls/ui-notifications';
import { provideNgxSkeletonLoader } from 'ngx-skeleton-loader';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { TranslationsLoaderService } from '@ls/data-access-regionalization';
import { REGIONALIZATION_DEFAULT_LANGUAGE } from '@ls/models-regionalization';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    provideStore(),
    provideEffects(),
    provideAnimationsAsync(),
    provideToastr(NOTIFICATIONS_GLOBAL_CONFIG),
    provideNgxSkeletonLoader(),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useExisting: TranslationsLoaderService,
      },
      fallbackLang: REGIONALIZATION_DEFAULT_LANGUAGE.code,
    }),
    {
      provide: ENVIRONMENT_INJECTION_TOKEN,
      useValue: environment,
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'outline',
        subscriptSizing: 'dynamic',
      },
    },
    ...environment.providers,
  ],
};
